<script>
import MainModal from "@/package/components/MainModal.vue";
import MainButton from "@/components/helpers/MainButton.vue";
import MainInput from "@/components/helpers/MainInput.vue";

export default {
  name: "CertificatesConfirmModal",

  emits: ["close", "confirm", "resend"],

  components: { MainInput, MainButton, MainModal },

  props: {
    isShowModal: {
      type: Boolean,
      default: false,
    },

    isConfirmCertLoading: {
      type: Boolean,
      default: false,
    },

    phone: {
      type: String,
      required: true,
    },

    confirmType: {
      type: String,
      default: "phone",
    },

    errorMessage: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      code: "",
      timer: 59,
      timerId: null,
    };
  },

  watch: {
    isShowModal() {
      this.timer = 59;

      if (!this.isShowModal) {
        this.code = "";
        clearInterval(this.timer);
      } else {
        this.startTimer();
      }
    },

    timer() {
      if (this.timer === 0) {
        this.stopTimer();
      }
    },
  },

  computed: {
    isShowResendButton() {
      return this.timer === 0;
    },

    formattedTimer() {
      return this.timer > 9 ? this.timer : `0${this.timer}`;
    },
  },

  methods: {
    startTimer() {
      this.timerId = setInterval(() => this.timer--, 1000);
    },

    stopTimer() {
      clearInterval(this.timerId);
    },

    resend() {
      this.timer = 59;
      this.startTimer();
      this.$emit("resend");
    },
  },
};
</script>

<template>
  <MainModal
    class="certificates-confirm-modal"
    :show-modal="isShowModal"
    @close="$emit('close')"
  >
    <h1>Код подтверждения</h1>

    <template v-if="confirmType === 'vk'">
      <p>
        Для получения кода необходимо, чтобы номер телефона был привязан к
        странице. Убедитесь, что ваша страница открыта и вам можно отправлять
        сообщения.
      </p>

      <p>
        Введите код подтверждения, который был вам отправлен в ВКонтакте на
        номер <span>{{ phone }}</span>
      </p>
    </template>

    <template v-else-if="confirmType === 'whatsapp'">
      <p>
        Введите код подтверждения, который был вам отправлен в WhatsApp на номер
        <span>{{ phone }}</span>
      </p>
    </template>

    <template v-else-if="confirmType === 'push'">
      <p>
        Введите код подтверждения, который был вам отправлен как
        Push-уведомление в RC.Pay на номер <span>{{ phone }}</span>
      </p>
    </template>

    <template v-else>
      <p>
        Введите последние 4 цифры телефона, с которого вам поступит звонок на
        номер <span>{{ phone }}</span>
      </p>

      <p>
        Для клиентов, которые совершают операцию на номер телефона не
        российского оператора связи, необходимо ответить на звонок и прослушать
        код
      </p>
    </template>

    <MainInput
      v-model="code"
      class="certificates-confirm-modal__input"
      :label="'4 цифры кода'"
      :background="'white'"
      :mask="'####'"
      :error="!!errorMessage"
      :error-message="errorMessage"
    >
      <div class="certificates-confirm-modal__wrapper">
        <MainButton
          v-if="isShowResendButton"
          class="certificates-confirm-modal__button-resend"
          :title="'Отправить повторно'"
          :color="'blue'"
          @click="resend"
        />
        <p v-else>Позвонить повторно через 0:{{ formattedTimer }}</p>
      </div>
    </MainInput>

    <MainButton
      :title="'Оплатить'"
      :color="'dark'"
      :loading="isConfirmCertLoading"
      :disabled="code.length < 4 || isConfirmCertLoading"
      @click="$emit('confirm', code)"
    />
  </MainModal>
</template>

<style lang="scss" scoped>
.certificates-confirm-modal {
  ::v-deep .main-modal__container {
    max-width: 500px;
    width: 100%;
  }

  h1 {
    @include title-3;
    color: $dark-primary;
    margin-bottom: 24px;
  }

  p {
    @include text-2;
    color: $dark-primary;

    &:not(:last-of-type) {
      margin-bottom: 8px;
    }

    span {
      @include text-2-bold;
    }
  }

  &__input {
    margin-top: 24px;

    p {
      @include caption-1;
      color: $dark-sixth;
    }
  }

  &__wrapper {
    margin-top: 8px;
    margin-left: 4px;
  }

  &__button-resend {
    @include caption-1;
  }
}
</style>
